import { takeLatest, put, call } from 'redux-saga/effects';
import {
    setLoading,
    setSuccess,
    setRoleList,
    setRoleCreation,
    clearRoleData,
    setGroupPermissionsList,
    setPermissionsList,
    setLoadingGroupPermissions,
    setLoadingPermissions
} from '@store/reducers/roleReducer';
import {
    fetchingRoleList,
    createRole,
    getRoleDetail,
    updateRole,
    clearRole,
    fetchGroupPermissionsList,
    fetchPermissionsList
} from '@store/actions/roleActions';
import { toast } from 'react-toastify';
import { history } from '@utils/BrowserHistory';
import { resourceService } from '@libs/axios';
import { ResponseType } from '@store/index';
// just draft
const API_URL = process.env.REACT_APP_API_URL;

function* fetchRoleListData(action: ReturnType<typeof fetchingRoleList>): Generator<any, void, any> {
    const { code_name, status, page = 1, page_size = 50 } = action.payload || {};
    yield put(setLoading(true));
    try {
        const response: ResponseType = yield call(
            resourceService.get,
            API_URL + '/api/roles/', {
            params: {
                code_name,
                status,
                page,
                page_size
            }
        }
        );

        if (response?.data) {
            yield put(setRoleList(response.data));
            yield put(setLoading(false));
        }
    } catch (e: any) {
        yield put(setLoading(false));
        let error: Error = e;
        console.log(error);
    }
}

function* createRoleSaga(action: ReturnType<typeof createRole>): Generator<any, void, any> {
    yield put(setSuccess(false));
    yield put(setLoading(true));
    try {
        const response: ResponseType = yield call(resourceService.post, API_URL + '/api/roles/', {
            ...action.payload
        });
        if (response.status == 201) {
            history.push(`/admin/roledetail/?mode=view&id=${response.data.id}`);
            yield put(setSuccess(true));
            toast.success('Tạo vai trò mới thành công');
            yield put(setLoading(false));
            yield put(setRoleCreation(response.data));
        } else {
            yield put(setSuccess(false));
            yield put(setLoading(false));
        }
    } catch (error: any) {
        const errorMessage = error?.response?.data?.detail || error?.message || 'An error occurred';
        console.log(errorMessage);
        toast.error(`Tạo vai trò mới thất bại ${errorMessage}`);
        yield put(setSuccess(false));
        yield put(setLoading(false));
    }
}

function* getRoleDetailSaga(action: any): Generator<any, void, any> {
    const { id } = action.payload;
    yield put(setLoading(true));
    try {
        const response: ResponseType = yield call(resourceService.get, API_URL + `/api/roles/${id}/`);
        if (response?.data) {
            yield put(
                setRoleCreation({
                    name: response.data?.name,
                    code: response.data?.code,
                    description: response.data?.description,
                    status: response.data?.status,
                    group_permissions: response.data?.group_permissions,
                    permissions: response.data?.permissions
                }),
            );
            yield put(setLoading(false));
        }
    } catch (error: any) {
        yield put(setLoading(false));
        console.log(error);
    }
}

function* clearRoleSaga(): Generator<any, void, any> {
    yield put(clearRoleData());
}

function* updateRoleSaga(action: any): Generator<any, void, any> {
    yield put(setSuccess(false));
    yield put(setLoading(true));
    try {
        const { data, id } = action.payload;
        const updatedData = {
            ...data,
        };

        const response: any = yield call(resourceService.put, API_URL + `/api/roles/${id}/`, updatedData);
        if (response.status == 200) {
            toast.success('Chỉnh sửa thông tin vai trò thành công');
            yield put(setSuccess(true));
            yield put(setLoading(false));
            yield put(
                setRoleCreation({
                    name: response.data?.name,
                    code: response.data?.code,
                    description: response.data?.description,
                    status: response.data?.status,
                    group_permissions: response.data?.group_permissions,
                    permissions: response.data?.permissions
                }),
            );
            history.push(`/admin/roledetail/?mode=view&id=${response.data.id}`);
        } else {
            yield put(setSuccess(false));
            yield put(setLoading(false));
        }
    } catch (error: any) {
        const errorMessage = error?.response?.data?.detail || error?.message || 'An error occurred';
        console.log(errorMessage);
        toast.error(`Chỉnh sửa thông tin vai trò thất bại: ${errorMessage}`);
        yield put(setSuccess(false));
        yield put(setLoading(false));
    }
}

function* fetchGroupPermissionsListSaga(action: any): Generator<any, void, any> {
    try {
        yield put(setLoadingGroupPermissions(true));
        const { page = null, page_size = null, status = null } = action.payload || {};
        const response: any = yield call(
            resourceService.get,
            API_URL + `/api/group_permissions/`,
            {
                params: {
                    page,
                    page_size,
                    status
                }
            }
        );
        if (response.status === 200) {
            yield put(setGroupPermissionsList(response.data?.results));
            yield put(setLoadingGroupPermissions(false));
        }
    } catch (error: any) {
        yield put(setLoadingGroupPermissions(false));
        console.log(error);
    }
}

function* fetchPermissionsListSaga(action: any): Generator<any, void, any> {
    try {
        yield put(setLoadingPermissions(true));
        const { page = null, page_size = null } = action.payload || {};
        const response: any = yield call(
            resourceService.get,
            API_URL + `/api/permissions/`,
            {
                params: {
                    page,
                    page_size
                }
            }
        );
        if (response.status === 200) {
            yield put(setPermissionsList(response.data?.results));
            yield put(setLoadingPermissions(false));
        }
    } catch (error: any) {
        yield put(setLoadingPermissions(false));
        console.log(error);
    }
}

function* roleSaga(): Generator<any, void, any> {
    yield takeLatest(fetchingRoleList, fetchRoleListData),
        yield takeLatest(createRole, createRoleSaga),
        yield takeLatest(getRoleDetail, getRoleDetailSaga),
        yield takeLatest(clearRole, clearRoleSaga),
        yield takeLatest(fetchGroupPermissionsList, fetchGroupPermissionsListSaga),
        yield takeLatest(fetchPermissionsList, fetchPermissionsListSaga),
        yield takeLatest(updateRole as any, updateRoleSaga)
}

export default roleSaga;
